import React, { useMemo } from 'react';

import Charts from 'react-apexcharts';
import * as PropTypes from 'prop-types';

export default function Chart({ name, data, categories }) {
  const options = useMemo(
    () => ({
      chart: {
        id: 'basic-bar',
        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: 'stepline',
      },
      markers: {
        size: 0,
      },
      xaxis: {
        categories,
      },
    }),
    [categories]
  );

  return (
    <Charts
      options={options}
      series={[{ name, data }]}
      type="line"
      width="100%"
      height="250"
    />
  );
}

Chart.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
  categories: PropTypes.arrayOf(PropTypes.any).isRequired,
};
